var _circle, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 10,
    r: 10,
    fill: "#0085FF",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8899 15V16H20.0199C19.2799 16 18.6799 16.6 18.6799 17.35V17.65C18.6799 18.4 18.0799 19 17.3299 19C16.5899 19 15.9899 18.4 15.9899 17.65V17.35C15.9899 16.6 15.3799 16 14.6399 16C13.8999 16 13.2999 16.6 13.2999 17.35V17.65C13.2999 18.4 12.6899 19 11.9499 19C11.2099 19 10.5999 18.4 10.5999 17.65V17.35C10.5999 16.6 9.99986 16 9.25986 16C8.51986 16 7.90986 16.6 7.90986 17.35V17.65C7.90986 18.4 7.30986 19 6.56986 19C5.81986 19 5.21986 18.4 5.21986 17.65V17.33C5.21986 16.59 4.62986 15.99 3.89986 15.98H3.10986V15C3.10986 13.62 4.14986 12.45 5.55986 12.11C5.83986 12.04 6.12986 12 6.43986 12H17.5599C17.8699 12 18.1599 12.04 18.4399 12.11C19.8499 12.45 20.8899 13.62 20.8899 15Z",
    fill: "#0085FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4401 9.17V10.58C18.1501 10.52 17.8601 10.5 17.5601 10.5H6.44006C6.14006 10.5 5.85006 10.53 5.56006 10.59V9.17C5.56006 7.97 6.64006 7 7.98006 7H16.0201C17.3601 7 18.4401 7.97 18.4401 9.17Z",
    fill: "#0085FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5.55039V7.01039H7.98C7.72 7.01039 7.48 7.04039 7.25 7.10039V5.55039C7.25 5.20039 7.59 4.90039 8 4.90039C8.41 4.90039 8.75 5.20039 8.75 5.55039Z",
    fill: "#0085FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 5.33008V7.10008C16.52 7.03008 16.28 7.00008 16.02 7.00008H15.25V5.33008C15.25 4.92008 15.59 4.58008 16 4.58008C16.41 4.58008 16.75 4.92008 16.75 5.33008Z",
    fill: "#0085FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 4.82V7H11.25V4.82C11.25 4.37 11.59 4 12 4C12.41 4 12.75 4.37 12.75 4.82Z",
    fill: "#0085FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23.2505C22 23.6605 21.66 24.0005 21.25 24.0005H2.75C2.34 24.0005 2 23.6605 2 23.2505C2 22.8405 2.34 22.5005 2.75 22.5005H3.11V17.4805H3.72V17.5505C3.72 18.8905 4.6 20.1305 5.91 20.4205C6.93 20.6605 7.9 20.3305 8.56 19.6805C8.94 19.3005 9.56 19.2905 9.94 19.6705C10.46 20.1805 11.17 20.5005 11.95 20.5005C12.73 20.5005 13.44 20.1905 13.96 19.6705C14.34 19.3005 14.95 19.3005 15.34 19.6805C15.99 20.3305 16.96 20.6605 17.99 20.4205C19.3 20.1305 20.18 18.8905 20.18 17.5505V17.5005H20.89V22.5005H21.25C21.66 22.5005 22 22.8405 22 23.2505Z",
    fill: "#0085FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon2);
export default __webpack_public_path__ + "static/media/chart-icon-2.e50d885f1b578dd74e495f5159f11a2c.svg";
export { ForwardRef as ReactComponent };